import { goThroughAndTouch, showAllInvalid } from './formevents'
import { inputSelectAriaCheckActiveState } from './inputs'
import * as _ from 'lodash'
import { isPlatformBrowser } from '@angular/common'


// state & popstate fill

/**
 * select index on state by function
 * @param stateObj - document state select object
 * @param func - filter predicate
 */
function setStateByFilter(that, document, stateObj, func: (x: any) => boolean): void {
  that.logger.info(stateObj.options)
  stateObj.selectedIndex = _.findIndex(stateObj.options, func)
  inputSelectAriaCheckActiveState(stateObj.parentElement)
}

/**
 * dynamically set provided state in form
 * @param state_abbreviation - state.abbreviation
 */
export function setStateAs(that, document, state_abbreviation): void {
    if (!isPlatformBrowser(this.platformId)) {
    return;
  }
  const stateValue = that.states.find(x => x.abbreviation === state_abbreviation)
  that.logger.info(stateValue)
  const stateOptionLarge = document.getElementById('stateOptionLarge') as any
  if (stateOptionLarge) {
    setStateByFilter(that, document,
      stateOptionLarge,
      (x: any) => x.innerText === stateValue.name)
    return
  }
  const stateOptionSmall = document.getElementById('stateOptionSmall') as any
  if (stateOptionSmall) {
    setStateByFilter(that, document,
      stateOptionSmall,
      (x: any) => x.innerText === stateValue.abbreviation)
    return
  }
}

/**
 * check navigation state and if need restore form values
 */
export function checkAndRestoreForm(that, document) {
  const prev = that.pageNavigationService.getPrevState()
  const current = that.pageNavigationService.getCurrentState()
  const isOpenNeeded = that.pageNavigationService.openNow
  if (!isOpenNeeded) {
    return
  }
  // our case or restoring
  if (current && current.trigger === 'popstate') {
    const type = that.modalStateService.getFromLocalStorage('modalType')
    const loanInfo = that.modalStateService.getFromLocalStorage('loanInfo')
    that.logger.info(type)
    that.logger.info(loanInfo)
    that.loanInfo = loanInfo
    that.loanAmount = loanInfo.amount
    that.pageNavigationService.openNow = false
    setTimeout(() => {

      goThroughAndTouch(that, document)
      // reregister event (?)
      showAllInvalid(that, document)
      // let el = document.getElementById('formId')
      // that.clickout({target: el, currentTarget: el})
      // that.loanForm.markAllAsTouched()
    }, 100)
  }
}
